// Standard documentation for the normal app view
export const documentation = `# Quick Start Guide

---

🚨 **WARNING:** Early Alpha version—expect rough edges! I encourage you to **battle-test** and share your feedback. Let me know what works, what breaks, and what could be better. Mike P.  
👉 [Submit feedback](https://metarouter.notion.site/1b7c1603c45780c38da2c253bd10d118?pvs=105)

## Basic Navigation

### 🔄 Pan & Move Around
- **Spacebar + Drag**: Hold spacebar and drag to pan
- **Scroll**: Scroll up/down to move vertically
- **Middle Mouse**: Click and drag with middle mouse button
- **Right Mouse**: Click and drag with right mouse button

### 🔍 Zoom In & Out
- **Pinch**: Pinch to zoom on trackpad
- **Cmd/Ctrl + Scroll**: Hold command/control and scroll

---

## Working with Nodes

### ➕ Adding Nodes
- **Quick Search**: Press Enter to open search, use arrow keys to navigate, Enter to select
- **Click & Drag**: Add a node from the left panel and drag it onto the canvas
- **Click**: Click on a node in the left panel to add it at the center of the view

### 🖱️ Selecting & Manipulating
- **Drag Selection**: Click and drag on empty canvas to create a selection box
- **Multi-Select**: Hold Shift while clicking to select multiple nodes
- **Move**: Click and drag selected nodes
- **Delete**: Press Delete or Backspace to remove selected nodes or edges

### 🔗 Connections
- **Create Connection**: Drag from a node's handle to another node
- **Disable Auto-Connect**: Hold Shift to temporarily disable proximity connection
- **Delete Connection**: Select an edge and press Delete or Backspace

---

## Coming Soon
- Copy/paste functionality
- Undo/redo operations

## Tips
- Save your work frequently
`;

// Preview documentation for the preview mode
export const previewDocumentation = `# Preview Canvas Controls

## Basic Navigation

### Pan & Move Around
- **Spacebar + Drag**: Hold spacebar and drag to pan
- **Scroll**: Scroll up/down to move vertically
- **Middle Mouse**: Click and drag with middle mouse button
- **Right Mouse**: Click and drag with right mouse button

### Zoom In & Out
- **Pinch**: Pinch to zoom on trackpad
- **Cmd/Ctrl + Scroll**: Hold command/control and scroll

### Selecting
- **Click**: Select a node to view its details

## About Preview Mode
The Preview Mode provides a read-only or limited-interaction version of the MetaRouter Architect. For full editing capabilities, sign up with your work email.
`;
